import {
  Container,
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

export const FAQ = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const accordionSx = {
    boxShadow: "0px 0.5px 1.25px rgba(0, 0, 0, 0.5)",
    padding: "15px",
  };

  const headingSx = {
    fontSize: {
      xs: "1.20rem",
      sm: "1.25rem",
      md: "1.30rem",
      lg: "1.35rem",
    },
    fontFamily: "Montserrat, sans-serif",
  };

  const detailSx = {
    fontSize: {
      xs: "1.0rem",
      sm: "1.0rem",
      md: "1.0rem",
      lg: "1.0rem",
    },
    fontFamily: "Montserrat, sans-serif",
  };

  return (
    <div className="bg-white text-black">
      <Container className="py-12 flex flex-col gap-8 bg-white">
        <p className="md:text-5xl text-3xl text-center">
          Frequently Asked Questions (FAQs)
        </p>

        <Typography variant="h6" align="center" className="text-gray-700" sx={headingSx}>
          Here are some common questions we get about Diamedic. If you have any
          other inquiries, feel free to reach out to us!
        </Typography>

        <Box className="space-y-4">
          {[
            { panel: "panel1", question: "What is a Diamedic card?", answer: "A Diamedic card is a compact, wallet-sized card with a unique QR code that links to your emergency medical details. It is designed specifically for diabetics and allows important information such as insulin types, dosages, and emergency instructions to be quickly accessed by first responders or members of the public." },
            { panel: "panel2", question: "How do I get my card?", answer: "Simply fill out your emergency medical information through our easy-to-use online form, and we'll generate your Diamedic card with a unique QR code that links to your personal details. We then print and ship it directly to you." },
            { panel: "panel3", question: "How long does it take to receive my card?", answer: "Once your order is placed, you can expect to receive your Diamedic card within 4-7 business days. You'll receive an order dispatched email when your card has been printed and sent out for delivery. Any delays will be communicated accordingly." },
            { panel: "panel4", question: "Does the card work offline?", answer: "Unfortunately not. The card requires an internet connection to display your full emergency profile. This allows us to keep your information up to date and enable features like SMS alerts. While it won't work without an active connection, this trade-off ensures a richer, more reliable experience when scanned." },
            { panel: "panel5", question: "What happens if my card is lost or damaged?", answer: "If your Diamedic card is lost or damaged and you have a valid order, please contact us and we'll do our best to remedy the situation." },
            { panel: "panel6", question: "How secure is my personal information?", answer: "Your personal information is securely stored and accessible via the QR code on your card. To ensure that first responders and bystanders can quickly access your emergency details in a critical situation, the QR code does not require login authentication. This means that anyone who scans your card will be able to view the information, which is a necessary trade-off to prioritize accessibility during emergencies." },
            { panel: "panel7", question: "Can I update my medical details on the card?", answer: "Yes! You can update your medical information anytime via our portal. Once updated, the QR code on your Diamedic card will reflect the changes." },
            { panel: "panel8", question: "Why is it priced at £14.99?", answer: "Traditional emergency cards typically cost between £4 and £10 and only display limited, static information, which means you need to replace the card every time your details change. Our card goes far beyond that. It links to a dynamic, easy-to-read emergency page with all your essential diabetic information and includes automatic SMS notifications to your emergency contacts - all at no extra cost. Plus, any new features we add to the user dashboard will be included for free." },
          ].map(({ panel, question, answer }) => (
            <Accordion key={panel} sx={accordionSx} expanded={expanded === panel} onChange={handleChange(panel)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} id={`${panel}-header`}>
                <Typography sx={{ ...headingSx, fontWeight: expanded === panel ? "bold" : "normal" }} variant="h6">
                  {question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={detailSx}>{answer}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </div>
  );
};
